import React from 'react';
import { darken } from 'polished';
import { useTheme } from 'styled-components';
import { cn } from '../../../../../utils/tailwind';

function getContrastColor(bgColor: string) {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 130 ? 'black' : '#ffffff';
}

interface ChartTooltipWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    point?: boolean;
    color?: string;
}

export const Wrapper: React.FC<ChartTooltipWrapperProps> = ({ point, color, className, children, ...props }) => {
    const theme = useTheme();
    const backgroundColor = color ? darken(0.1, color) : theme.palette.color.secondary.main;
    const textColor = color ? getContrastColor(darken(0.2, color)) : theme.palette.common.textInverse;

    return (
        <div
            className={cn('relative rounded-[0.8rem] px-[1rem] py-[0.8rem] shadow-large', className)}
            style={{ background: backgroundColor, color: textColor }}
            {...props}
        >
            {children}
            {point ? (
                <span
                    className="absolute -bottom-[2rem] left-1/2 block h-[1.2rem] w-[1.2rem] -translate-x-1/2 rounded-[2rem] border-[0.2rem] border-brand-secondary bg-neutral-white"
                    aria-hidden
                />
            ) : null}
        </div>
    );
};

export const Date: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-vsmall font-bold opacity-60', className)} {...props} />
);

export const Value: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-medium font-bold', className)} {...props} />
);

export const Percentafe: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-medium font-medium', className)} {...props} />
);

export const Percentage: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={className} {...props} />
);

export const Header: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('mb-[0.6rem] flex items-center justify-between gap-[1.6rem]', className)} {...props} />
);

export const Type: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-vsmall font-bold opacity-60', className)} {...props} />
);

export const Unit: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-medium font-bold', className)} {...props} />
);

export const Amount: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={cn('text-xsmall font-bold opacity-60', className)} {...props} />
);
